module.exports = __webpack_public_path__ + "img/background_math2.7f56cfe6.png";